module.exports = __webpack_public_path__ + "static/media/ArrowLeft.ba4e1122.svg";